import { MenuCategory, MenuItem } from './types';

export const menuCategories: Record<string, Omit<MenuCategory, 'type'>> = {
  Add: {
    label: 'ADD_MENU'
  },
  Dashboard: {},
  Manage: {
    label: 'MANAGE_MENU'
  },
  Reports: {
    component: 'Reports',
    label: 'REPORTS_MENU'
  }
};

export const menuItems: Record<string, Omit<MenuItem, 'type'>> = {
  AddConnector: {
    icon: 'power',
    label: 'POINTS_MENU',
    route: '/add/box'
  },
  AddLocation: {
    icon: 'add_location_alt',
    label: 'LOCATION_MENU',
    route: '/add/station'
  },
  BulkOperations: {
    icon: 'graph_4',
    label: 'BULK_OPERATIONS_MENU',
    route: '/bulk-operations'
  },
  Companies: {
    icon: 'business',
    label: 'COMPANIES_MENU',
    route: '/companies'
  },
  CompanyFeatures: {
    icon: 'extension',
    label: 'FEATURES',
    route: 'features'
  },
  CompanyFinancials: {
    icon: 'table_chart',
    label: 'FINANCIALS_MENU',
    route: 'financials'
  },
  CompanyInvoices: {
    icon: 'receipt_long',
    label: 'INVOICES_MENU',
    route: 'invoices'
  },
  CompanyPayouts: {
    icon: 'paid',
    label: 'PAYMENTS_MENU',
    route: 'payments'
  },
  CompanySettings: {
    icon: 'account_balance',
    label: 'BILLING_INFORMATION_MENU',
    route: 'settings'
  },
  CompanySettlements: {
    icon: 'currency_exchange',
    label: 'SETTLEMENTS_MENU',
    route: 'settlements'
  },
  Connectors: {
    icon: 'power',
    label: 'POINTS_MENU',
    route: '/points'
  },
  ConnectorUsageReports: {
    component: 'BusinessReports',
    icon: 'electric_meter',
    label: 'POINT_USAGE_REPORT_MENU',
    route: '/reports/point-usage'
  },
  Dashboard: {
    exactMatch: true,
    icon: 'home',
    label: 'DASHBOARD_MENU',
    route: '/'
  },
  Groups: {
    icon: 'groups',
    label: 'GROUPS_MENU',
    route: '/groups'
  },
  Insights: {
    icon: 'insights',
    label: 'INSIGHTS',
    route: '/insights'
  },
  Invoices: {
    icon: 'receipt_long',
    label: 'INVOICES_MENU',
    route: '/invoices'
  },
  LocationReports: {
    icon: 'assignment',
    label: 'LOCATION_REPORTS_MENU',
    route: '/reports/location-reports'
  },
  Locations: {
    icon: 'place',
    label: 'LOCATIONS_MENU',
    route: '/stations'
  },
  OCPPTestTool: {
    icon: 'assignment_turned_in',
    label: 'OCPP_TEST_TOOL',
    route: '/box-test'
  },
  PackageTemplates: {
    icon: 'package',
    label: 'PACKAGE_TEMPLATES_MENU',
    route: '/package-templates'
  },
  ProductTemplates: {
    icon: 'inventory',
    label: 'PRODUCT_TEMPLATES_MENU',
    route: '/product-templates'
  },
  Stickers: {
    icon: 'qr_code_2',
    label: 'STICKERS_MENU',
    route: '/stickers'
  },
  UserReports: {
    component: 'UserReports',
    icon: 'contact_page',
    label: 'USER_REPORT_MENU',
    route: '/reports/users'
  },
  Users: {
    icon: 'group',
    label: 'USERS_MENU',
    route: '/users/search'
  }
};
